<!-- <app-loader></app-loader> -->
<app-header></app-header>

<div class="wrapper">
    <div class="container-fluid">

        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a [routerLink]="['/show-equipment']">Application Settings</a></li>
                            <li class="breadcrumb-item active">Edit Equipment</li>
                        </ol>
                    </div>
                    <h4 class="page-title">Edit Equipment</h4>
                </div>
            </div>
        </div>
        <!-- end page title end breadcrumb -->
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="alert alert-success" role="alert" *ngIf="sucMsg">
                            {{ successMessage }}
                        </div>
                        <div class="alert alert-danger" role="alert" *ngIf="errMsg">
                            {{ errorMessage }}
                        </div>
                        <form class="form-horizontal m-t-20" action="">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Edit Equipment</label>
                                        <input type="text" [(ngModel)]="loginModel.equipment_type" name="equipment_type"
                                            class="form-control" required>
                                            <span class="err_msg" *ngIf="addValidationError.equipment_type">{{addValidationError.equipment_type}}</span>
                                    </div>
                                    <input type="hidden" [(ngModel)]="loginModel.id" name="id" required=""
                                        class="form-control">
                                </div>

                            </div>

                            <div class="sub_btn">
                                <!-- <button class="btn btn-primary" type="button">Add</button> -->
                                <button class="btn btn-primary" (click)="update_equipment()" type="button">Update
                                    Equipment</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div> <!-- end container -->
</div>
<app-footer></app-footer>